export const baxiBrandColor = '#005b99';
export const baxi_colors = (dark) => ({
    primary: {
        light: dark ? '#4397C8' : '#4e88ca',
        main: dark ? '#157DBB' : baxiBrandColor,
        dark: dark ? '#0E5782' : '#00326a',
        contrastText: '#f0f0f0',
    },
    secondary: {
        light: '#ffe54c',
        main: '#ffb300',
        dark: '#c68400',
        contrastText: '#000000',
    },
});
export const baxi_theme_fonts = {
    fontSize: 16,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 800,
};
